import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as api from '../api';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export default function MiniHome() {
    const nav = useNavigate();
    const { user } = useAuth();
    const toast = useToast();
    const [subjects, setSubjects] = useState([]);
    const [topics, setTopics] = useState([]);
    const [subject, setSubject] = useState('');
    const [topic, setTopic] = useState('');
    const [spinning, setSpinning] = useState(false);
    const [spinValue, setSpinValue] = useState('🎰');

    useEffect(() => { api.getSubjects().then(r => setSubjects(r.data)).catch(e => toast(e.message, 'error')); }, []);
    useEffect(() => {
        if (!subject) { setTopics([]); setTopic(''); return; }
        api.getTopics(subject).then(r => setTopics(r.data)).catch(() => setTopics([]));
    }, [subject]);

    const randomLabels = useMemo(() => ['Savol', 'Mavzu', 'Fan', 'Test', 'Quiz'], []);
    const spin = () => {
        if (!subject) { toast('Avval fanni tanlang', 'error'); return; }
        setSpinning(true);
        let i = 0;
        const timer = setInterval(() => {
            setSpinValue(randomLabels[i % randomLabels.length]); i += 1;
        }, 140);
        setTimeout(async () => {
            clearInterval(timer); setSpinValue('🎯');
            try {
                const res = await api.createSelfExam({
                    title: `${subject} — tezkor test`,
                    startDateTime: new Date().toISOString(),
                    durationMinutes: 15,
                    dynamicCriteria: { subject, topic, count: 10, label: 'basic' }
                });
                await api.allowParticipant({ examId: res.data._id, userId: user.id });
                nav(`/participant/exam/${res.data._id}`);
            } catch (e) { toast(e.message, 'error'); }
            finally { setSpinning(false); }
        }, 1600);
    };

    return (
        <div className="page" style={{ maxWidth: 860, margin: '0 auto' }}>
            <div style={{ textAlign: 'center', padding: '18px 0 24px' }}>
                <div style={{ fontSize: 42, marginBottom: 8 }}>🎓</div>
                <h1 style={{ fontSize: 30, marginBottom: 8 }}>UniQuiz</h1>
                <p style={{ color: 'var(--muted)' }}>Salom, {user?.name || 'talaba'}! Fan tanlang va testni boshlang.</p>
            </div>

            <div className="card" style={{ marginBottom: 16 }}>
                <h2 style={{ fontSize: 18, marginBottom: 14 }}>📚 Fanni tanlang</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 10 }}>
                    {subjects.map((s) => (
                        <button key={s} onClick={() => setSubject(s)} className="btn btn-ghost" style={{ justifyContent: 'center', borderColor: subject === s ? 'var(--accent)' : 'var(--border)', color: subject === s ? 'var(--accent)' : 'var(--text)', minHeight: 56 }}>{s}</button>
                    ))}
                </div>
                {subject && (
                    <div className="form-row" style={{ marginTop: 16 }}>
                        <div className="form-group">
                            <label>Mavzu (ixtiyoriy)</label>
                            <select value={topic} onChange={e => setTopic(e.target.value)}><option value="">Barcha mavzular</option>{topics.map(t => <option key={t} value={t}>{t}</option>)}</select>
                        </div>
                    </div>
                )}
            </div>

            <div className="card" style={{ textAlign: 'center', padding: '28px 22px' }}>
                <div style={{ fontSize: 40, fontFamily: 'var(--font-head)', fontWeight: 800, color: 'var(--accent)', marginBottom: 14, minHeight: 48 }}>{spinValue}</div>
                <h2 style={{ fontSize: 20, marginBottom: 8 }}>Savol barabani</h2>
                <p style={{ color: 'var(--muted)', marginBottom: 18 }}>Tanlangan fandan 10 ta tasodifiy boshlang‘ich darajadagi savol.</p>
                <button className="btn btn-primary" onClick={spin} disabled={spinning || !subject}>{spinning ? 'Baraban aylanmoqda...' : '🎰 Barabanni aylantirish'}</button>
            </div>
        </div>
    );
}
